/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Notetaker_HelpInputs */



/**
* | output |
* | --- |
* | "How does it work?" |
*
* @param {Onboarding_Notetaker_HelpInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_notetaker_help = /** @type {((inputs?: Onboarding_Notetaker_HelpInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Notetaker_HelpInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Hoe werkt dit?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comment ça marche ?")
	return /** @type {LocalizedString} */ ("How does it work?")
});